import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { CSS_SIZE_UNIT_PX } from "../../../../external/models/css-consts";

@Directive({
  selector: '[txtbFixRender]',
  standalone: false,
})
export class FixRenderDirective {
  @Input() set imgSrc(value: string | null) {
    this.resetTransform();
  }

  @HostListener('load') onImageLoaded(): void {
    this.updateTransform();
  }

  constructor(private hostRef: ElementRef, private renderer: Renderer2) {}

  private updateTransform(): void {
    this.renderer.setStyle(this.hostRef.nativeElement, 'transform', `translateZ(0${CSS_SIZE_UNIT_PX})`);
  }

  private resetTransform(): void {
    this.renderer.setStyle(this.hostRef.nativeElement, 'transform', 'none');
  }
}
